import React from 'react';
import { useNavigate } from 'react-router-dom';
import './MyAds.css';

const MyAds: React.FC = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  const handleHistory = () => {
    console.log('Navigate to ads history');
  };

  const handlePost = () => {
    console.log('Create new ad');
  };

  const handleCreateFirstAd = () => {
    console.log('Create first ad');
  };

  return (
    <div className="my-ads-container">
      {/* Header */}
      <header className="my-ads-header">
        <button className="my-ads-back-button" onClick={handleBack} aria-label="Go back">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        
        <h1 className="my-ads-title">My Ads</h1>
        
        <div className="my-ads-header-actions">
          <button className="my-ads-history-button" onClick={handleHistory}>
            <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
              <path d="M5.5 1V5.5L8 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <circle cx="5.5" cy="5.5" r="4.5" stroke="currentColor" strokeWidth="1.5"/>
            </svg>
            History
          </button>
          
          <button className="my-ads-post-button" onClick={handlePost}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M8 3V13M3 8H13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Post
          </button>
        </div>
      </header>

      {/* Empty State */}
      <div className="my-ads-content">
        {/* Blur Background Effect */}
        <div className="my-ads-blur-circle" />
        
        {/* Empty State Icon */}
        <div className="my-ads-empty-icon">
          <img 
            src="/06818a4b659f6c8de4a3f779febc420f8614a915.png" 
            alt="No ads"
            className="my-ads-icon-image"
          />
        </div>

        {/* Empty State Text */}
        <h3 className="my-ads-empty-title">No Active Ads</h3>
        <p className="my-ads-empty-description">
          Start trading by creating your first P2P<br />advertisement
        </p>

        {/* Create Button */}
        <button className="my-ads-create-button" onClick={handleCreateFirstAd}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M8 3V13M3 8H13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          Create Your First Ad
        </button>
      </div>

      {/* Footer Pagination */}
      <footer className="my-ads-footer">
        <div className="my-ads-pagination">
          <button className="my-ads-pagination-button" disabled>
            Previous
          </button>
          <span className="my-ads-pagination-text">Page 1 of 1</span>
          <button className="my-ads-pagination-button" disabled>
            Next
          </button>
        </div>
      </footer>
    </div>
  );
};

export default MyAds;